export default __webpack_public_path__ + "static/media/struct6.80837dee.png";